import { useRequestedAppLocale } from '@/i18n/context';

/** The person's own locale for dates, word breaks and case ("en-GB": 26 Sept). */
export function useIntlLocale() {
  const requested = useRequestedAppLocale();
  try {
    return Intl.getCanonicalLocales(requested)[0] ?? 'en';
  } catch {
    return 'en';
  }
}
